var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.1665H5C3.625 4.1665 2.5125 5.104 2.5125 6.24984L2.5 18.7498C2.5 19.8957 3.625 20.8332 5 20.8332H25C26.375 20.8332 27.5 19.8957 27.5 18.7498V6.24984C27.5 5.104 26.375 4.1665 25 4.1665ZM24.5 8.59359L15.6625 13.1978C15.2625 13.4061 14.7375 13.4061 14.3375 13.1978L5.5 8.59359C5.37466 8.53495 5.2649 8.45573 5.17736 8.36073C5.08982 8.26572 5.02633 8.1569 4.99072 8.04085C4.95511 7.9248 4.94813 7.80394 4.9702 7.68557C4.99226 7.56721 5.04292 7.45381 5.1191 7.35223C5.19528 7.25066 5.29541 7.16302 5.41341 7.09462C5.53141 7.02623 5.66484 6.97849 5.80562 6.95431C5.9464 6.93014 6.0916 6.93001 6.23244 6.95395C6.37328 6.97789 6.50683 7.02539 6.625 7.09359L15 11.4582L23.375 7.09359C23.4932 7.02539 23.6267 6.97789 23.7676 6.95395C23.9084 6.93001 24.0536 6.93014 24.1944 6.95431C24.3352 6.97849 24.4686 7.02623 24.5866 7.09462C24.7046 7.16302 24.8047 7.25066 24.8809 7.35223C24.9571 7.45381 25.0077 7.56721 25.0298 7.68557C25.0519 7.80394 25.0449 7.9248 25.0093 8.04085C24.9737 8.1569 24.9102 8.26572 24.8226 8.36073C24.7351 8.45573 24.6253 8.53495 24.5 8.59359Z",
    fill: "#FFCA09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f4b5bb465360fe709c898e0f2f3fa03c.svg";
export { ForwardRef as ReactComponent };